import React from 'react';

function Uzbekistan(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123966)">
        <mask
          id="mask0_800_123966"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123966)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16H36V24H0V16Z"
            fill="#14DC5A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V10H0V0Z"
            fill="#0099B5"
          />
          <path
            d="M-2.25 9.5H-2.75V10V16V16.5H-2.25H38.25H38.75V16V10V9.5H38.25H-2.25Z"
            fill="#F7FCFF"
            stroke="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.359 3.00637L15.6018 3.38034L15.818 2.62029L15.0927 2.06177H16.0401L16.3578 1.34253L16.7304 2.06177H17.538L16.9034 2.62029L17.2085 3.38034L16.359 3.00637ZM12.2997 5.29721L13.0569 4.92324L13.9065 5.29721L13.6014 4.53716L14.2359 3.97864H13.4283L13.0557 3.2594L12.738 3.97864H11.7907L12.516 4.53716L12.2997 5.29721ZM9.48111 6.96108L8.72395 7.33505L8.9402 6.575L8.21489 6.01648H9.16224L9.47997 5.29724L9.85254 6.01648H10.6601L10.0256 6.575L10.3307 7.33505L9.48111 6.96108ZM13.0569 6.96108L12.2997 7.33505L12.516 6.575L11.7907 6.01648H12.738L13.0557 5.29724L13.4283 6.01648H14.2359L13.6014 6.575L13.9065 7.33505L13.0569 6.96108ZM16.4094 6.96108L15.6522 7.33505L15.8684 6.575L15.1431 6.01648H16.0905L16.4082 5.29724L16.7808 6.01648H17.5884L16.9538 6.575L17.2589 7.33505L16.4094 6.96108ZM15.6522 5.29721L16.4094 4.92324L17.2589 5.29721L16.9538 4.53716L17.5884 3.97864H16.7808L16.4082 3.2594L16.0905 3.97864H15.1431L15.8684 4.53716L15.6522 5.29721ZM19.0265 7.33505L19.7837 6.96108L20.6333 7.33505L20.3282 6.575L20.9627 6.01648H20.1551L19.7825 5.29724L19.4648 6.01648H18.5175L19.2428 6.575L19.0265 7.33505ZM19.7837 4.92324L19.0265 5.29721L19.2428 4.53716L18.5175 3.97864H19.4648L19.7825 3.2594L20.1551 3.97864H20.9627L20.3282 4.53716L20.6333 5.29721L19.7837 4.92324ZM18.976 3.38034L19.7331 3.00637L20.5827 3.38034L20.2776 2.62029L20.9122 2.06177H20.1046L19.732 1.34253L19.4143 2.06177H18.4669L19.1922 2.62029L18.976 3.38034ZM23.1926 6.96108L22.4354 7.33505L22.6517 6.575L21.9264 6.01648H22.8737L23.1915 5.29724L23.564 6.01648H24.3716L23.7371 6.575L24.0422 7.33505L23.1926 6.96108ZM22.4354 5.29721L23.1926 4.92324L24.0422 5.29721L23.7371 4.53716L24.3716 3.97864H23.564L23.1915 3.2594L22.8737 3.97864H21.9264L22.6517 4.53716L22.4354 5.29721ZM23.1422 3.00637L22.385 3.38034L22.6013 2.62029L21.876 2.06177H22.8233L23.1411 1.34253L23.5136 2.06177H24.3212L23.6867 2.62029L23.9918 3.38034L23.1422 3.00637ZM6.62052 8.24062C6.62052 8.24062 3.90269 7.58539 3.95387 5.16191C4.00505 2.73842 6.75 2.10921 6.75 2.10921C5.62841 1.73167 2.31204 2.23828 2.25082 5.13734C2.1896 8.0364 5.57542 8.60752 6.62052 8.24062Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123966">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Uzbekistan;
